<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
// Vue
import { ref } from "vue"

// Types
import { LineBlock } from "@types"

// ================================
// TYPES & INTERFACES
// ================================
type Props = {
    lineBlocks: LineBlock
}

// ================================
// PROPS & EMITS
// ================================
defineProps<Props>()

// ================================
// REACTIVE STATE
// ================================

// ref du menu
const menuRef = ref()

// ================================
// METHODS
// ================================

/**
 * méthode pour ouvrir le menu
 * @param event
 */
const onToggleMenu = (event: Event) => {
    menuRef.value.toggle(event)
}
</script>

<template>
    <div class="meter_card_lines_blocks flex flex-col">
        <div class="flex flex-row justify-between mb-3">
            <div class="flex flex-wrap md:flex-row gap-3 pl-2">
                <!-- titre -->
                <div class="flex flex-wrap flex-row gap-2">
                    <div
                        v-for="(title, index) in lineBlocks.title"
                        :key="index"
                        class="flex flex-row gap-2 font-bold items-center"
                    >
                        <h4 class="text-nowrap">{{ title }}</h4>
                        <!-- si plusieurs titres ils sont séparé par • -->
                        <span
                            v-if="index < lineBlocks.title.length - 1"
                            class="text-cyan-400"
                        >
                            •
                        </span>
                    </div>
                </div>
                <!-- badges -->
                <BaseTag
                    v-for="(badge, index) in lineBlocks.badge"
                    :key="index"
                    :severity="badge.status"
                    v-tooltip.top="badge.tooltip || null"
                >
                    <div class="flex items-center gap-2">
                        <!-- icone -->
                        <BaseIcon
                            v-if="badge.icon"
                            :icon="badge.icon"
                            size="12px"
                        />
                        <!-- texte -->
                        <span>{{ badge.text }}</span>
                    </div>
                </BaseTag>
            </div>

            <!-- menu -->
            <div v-if="lineBlocks.menu && lineBlocks.menu.length">
                <a @click.prevent="onToggleMenu" class="cursor-pointer">
                    <BaseIcon icon="far fa-ellipsis" />
                </a>
                <BaseMenu ref="menuRef" :model="lineBlocks.menu" popup />
            </div>
        </div>
        <!-- lines -->
        <div v-for="(line, index) in lineBlocks.lines" :key="index">
            <BaseLineBlock :line="line"> </BaseLineBlock>
        </div>
        <!-- slot pour personnaliser le contenu de la ligne -->
        <slot name="footer"></slot>
    </div>
</template>

<style scoped></style>
